import Stomp from 'webstomp-client'
import SockJS from 'sockjs-client'
import {mixinChat} from '@/mixins/mixinChat'
import VueCookies from "vue-cookies";
import store from "@/store";
const VUE_APP_API_BASE_URL = 'http://localhost:8080'
const VUE_APP_API_BASE_DEV_URL = 'https://dms-gw.happymint.dev'
const VUE_APP_API_BASE_PRD_URL = 'https://ws-gw.happymint.kr'
export const mixinSocket = {
  mixins: [
    mixinChat
  ],
  data: () => ({
    pushFlag: true,
    url: '',
    stompClient: null,
    basicStompClient: null,
    roomNumber: '',
    isTyping: false,
    messages: [],
    onlineClass: '',
    readCount: 0,
    retryCount: 0,
    basicRetryCount: null,
    retryInterval: null,
    useInterval: false,
  }),
  methods: {
    getURL() {
      let baseURL = ''
      let loc = window.location.host
      if (loc.includes('localhost')) baseURL = `${VUE_APP_API_BASE_URL}`
      else if (loc.includes('happymint.dev')) baseURL = `${VUE_APP_API_BASE_DEV_URL}`
      else if (loc.includes('happymint.kr')) baseURL = `${VUE_APP_API_BASE_PRD_URL}`

      return baseURL + '/dms/v1/user/ws'
    },
    basicConnectSocket(url, subscribeChannels) {
      if (!url) url = this.getURL()
      this.url = url
      this.basicStompClient = Stomp.over(new SockJS(url))
      //this.stompClient.hasDebug = false;
      const header = {
        "Authorization": 'Bearer ' + VueCookies.get('dms-user-token'),
        "SUBSCRIBE_TO_CHANNEL": store.state.client.contract.realtalkMasterNo * 1,
        "SENDER_USER_TYPE": "dms-user",
        "SENDER_USER_KEY": store.state.auth.authUser.userKey
      }
      this.basicStompClient.connect(header, (frame) => {
        subscribeChannels.map(sub => {
            this.basicStompClient.subscribe(sub.url.replace("#{channel}",frame.headers['user-name']), sub.callback)
        })
      }, () => {
        // 재연결 시도
        this.disconnect()
        if (this.basicRetryCount === 10) {
          this.$confirm('서버와 연결이 끊겼습니다.<br>다시 연결하시겠어요?')
              .then(value => {
                if (value) {
                  window.location.reload()
                }
                this.basicRetryCount = 0
              })
        } else {
          if (this.url) {
            this.basicConnectSocket(this.url, subscribeChannels)
          }
          this.basicRetryCount++
        }
      })
      return this.basicStompClient;
    },
    connectSocket(SOCKET_URL, callback) {
      this.url = !SOCKET_URL?this.getURL():SOCKET_URL;
      const socket = new SockJS(this.url)
      this.stompClient = Stomp.over(socket)
      // this.stompClient.hasDebug = false;
      this.stompClient.connect({}, () => {
        this.stompClient.subscribe('/v1/user/sub/' + this.roomId, res => {
          let body = JSON.parse(res.body)
          this.pushFlag = true

          if (body.sendType === this.sendType.UNTYPING || body.sendType === this.sendType.SEND_FAIL) {
            this.pushFlag = false
            this.clearTyping(body.userType)
          } else if (body.sendType === this.sendType.SEND) {
            this.pushFlag = true
            this.clearTyping(body.userType)
          } else if (body.sendType === this.sendType.DELETED) {
            this.pushFlag = false
            this.deleteMessage(body)
          } else if (body.sendType === this.sendType.TYPING && body.userType == 'dms-user') {
            // 본인이 보낸 타이핑 메시지는 push 안함
            this.pushFlag = false
          }
          if (this.pushFlag) {
            this.pushMessage(body);
          }
          this.$nextTick(function () {
            // console.log('[단계별 스텝 CALL][getMemberStepCnt][END]');
            this.chatArea = this.$refs.chatArea;
            this.chatArea.scrollTo({top: this.chatArea.scrollHeight});
          });

        })
        if (callback) {
          callback()
        }
      }, () => {
        // 재연결 시도
        this.disconnect()
        if (this.retryCount === 10) {
          this.$confirm('채팅연결이 끊겼어요.<br>다시 연결하시겠어요?')
              .then(value => {
                if (value) {
                  window.location.reload()
                }
                this.retryCount = 0
              })
        } else {
          if (this.url) {
            this.connectSocket(this.url)
          }
          this.retryCount++
        }
      })

    },
    basicDisconnect() {
      if (this.basicStompClient && this.basicStompClient.connected) {
        this.basicStompClient.disconnect()
      } else {
        this.basicStompClient = null
      }
    },
    disconnect(message) {
      if (this.stompClient && this.stompClient.connected) {
        if (message) {
          this.send(message)
        }
        this.stompClient.disconnect()
      } else {
        this.stompClient = null
      }
    },
    send(message, callback) {
      // 이미 작성중이라면 한개만 보내도록 함.
      if (message.sendType === this.sendType.TYPING) {
        if (this.isTyping) return
        else {
          this.isTyping = true
        }
      } else if (message.sendType !== this.sendType.RECEIVE) {
        this.isTyping = false
      }
      // send () => 최종 메시지 보내는 행위를 하는 함수
      try {
        if (this.stompClient && this.stompClient.connected) {
          this.stompClient.send('/v1/user/pub/message', JSON.stringify(message), {})
          this.inputChange()
        } else {
          this.connectSocket(null,() => {
            this.stompClient.send('/v1/user/pub/message', JSON.stringify(message), {})
            this.inputChange()
          });
        }
      } catch (e) {
        console.log("message send error :" + e);
        this.$alert("메시지 전송 중 오류가 발생되었습니다.")
      }
      if (callback) {
        callback()
      }
    }
  }
}
